export let data = {
  title: "Data Operasi",
  backBtn: "/operasi",
  actionBtn: [],
  breadcrumb: [
    { title: "Operasi", link: "/operasi" },
    { title: "Input Data Operasi", active: true }
  ]
};
export let today=new Date();
import {getTime} from './helper.js';
export let time=getTime(today.getHours(),today.getMinutes());
export let upperForm = [
  {
    colnum: 3,
    columns: [
      {
        label: "Petugas",
        type: "select",
        placeholder: "Pilih Petugas",
        name: "id_petugas",
        value: 0,
        mandatory: true,
        additional: "",
        options: []
      }
    ]
  }
];
export let leftForm = [
  {
    colnum: 2,
    columns: [
      {
        label: "Sign in pukul",
        type: "time",
        placeholder: "",
        name: "sign_in",
        value: "",
        additional: ""
      }
    ]
  },
  {
    colnum: 1,
    columns: [
      {
        label: "Pasien sudah dikonfirmasi nama, prosedur,sisi/lokasi dan inform consent",
        type: "checkbox_old",single:true,
        header:"SEBELUM INDUKSI",
        name: "pre_induksi_konfirmasi",
        value: 0,
        mandatory: false,
        optional:true,
        multiple: false,
        options: [
          {
            label: "Ya",
            value: 1
          }
        ],
      }
    ]
  },
  {
    colnum: 1,
    columns: [
      {
        label: "Apakah sisi operasi sudah ditandai?",
        type: "checkbox_old",single:true,
        name: "pre_induksi_sisi_ditandai",
        value: 0,
        mandatory: false,
        optional:true,
        multiple: false,
        options: [
          {
            label: "Ya",
            value: 1
          }
        ],
      }
    ]
  },
  {
    colnum: 1,
    columns: [
      {
        label: "Upload Form Penandaan Lokasi Operasi",
        type: "file",
        name: "pre_induksi_file_penandaan",
        mandatory: false,
        optional:true,
      }
    ]
  },
  {
    colnum: 1,
    columns: [
      {
        label: "Apakah mesin Pulse oxymetri dan obat anestesi sudah dicek lengkap?",
        type: "checkbox_old",single:true,
        name: "pre_induksi_cek_oxymetri",
        value: 0,
        mandatory: false,
        optional:true,
        multiple: false,
        options: [
          {
            label: "Ya",
            value: 1
          }
        ],
      }
    ]
  },
  {
    colnum: 1,
    columns: [
      {
        name: "pre_induksi_alergi",
        type: "radio",
        label: "Apakah pasien mempunyai alergi?",
        mandatory: true,
        optional:false,
        options: [
          {label:'Ya',value:1},
          {label:'Tidak',value:0}
        ]
      }
    ]
  },
  {
    colnum: 1,
    columns: [
      {
        name: "pre_induksi_kesulitan_bernapas",
        type: "radio",
        label: "Kesulitan bernafas/resiko aspirasi",
        mandatory: true,
        optional:false,
        options: [
          {label:'Ya',value:1},
          {label:'Tidak',value:0}
        ]
      }
    ]
  },
  {
    colnum: 1,
    columns: [
      {
        name: "pre_induksi_resiko_darah",
        type: "radio_old",
        label: "Resiko kehilangan darah >500ml ( 7ml/kg pada anak )",
        mandatory:true,
        options: [
          {label:'Tidak',value:0},
          {label:'Ya, dan akses IV dan cairan sudah dipersiapkan',value:1}
        ]
      }
    ]
  },
  {
    colnum: 1,
    columns: [
      {
        label: "Tersedia produk darah",
        type: "text",
        placeholder: "",
        name: "pre_induksi_resiko_darah_ketersediaan",
        value: "",
        mandatory: false,
optional:true,
        additional: ""
      }
    ]
  },
];
export let middleForm = [
  {
    colnum: 2,
    columns: [
      {
        label: "Time out pukul",
        type: "time",
        placeholder: "",
        name: "time_out",
        value: null,
        additional: ""
      }
    ]
  },
  {
    colnum: 1,
    columns: [
      {
        label: "Semua anggota tim memperkenalkan diri dan perannya",
        type: "checkbox_old",single:true,
        header:"SEBELUM MULAI PEMBEDAHAN/IRIS",
        name: "pre_pembedahan_perkenalan",
        value: 0,
        mandatory: false,
        optional:true,
        multiple: false,
        options: [
          {
            label: "Ya",
            value: 1
          }
        ],
      }
    ]
  },
  {
    colnum: 1,
    class:'mb-0',
    columns: [
      {
        label: "Dokter bedah, anestesi dan perawat mengkonfirmasi",
        type: "checkbox_old",single:true,
        class:'mb-0',
        name: "pre_pembedahan_konfirmasi_nama_pasien",
        value: 0,
        mandatory: false,
        optional:true,
        multiple: false,
        options: [
          {
            label: "Nama Pasien",
            value: 1
          }
        ],
      }
    ]
  },
  {
    colnum: 1,
    columns: [
      {
        type: "checkbox_old",single:true,
        name: "pre_pembedahan_konfirmasi_prosedur",
        value: 0,
        mandatory: false,
        optional:true,
        multiple: false,
        options: [
          {
            label: "Prosedur sisi operasi dan posisi yang direncanakan",
            value: 1
          }
        ],
      }
    ]
  },
  {
    colnum: 1,
    columns: [
      {
        name: "pre_pembedahan_foto",
        type: "radio",
        label: "Foto Rontgen/Imaging",
        mandatory: true,
        optional:false,
        options: [
          {label:'Ya',value:1},
          {label:'Tidak perlu dilakukan',value:0}
        ]
      }
    ]
  },
  {
    colnum: 1,
    class:'mb-0',
    columns: [
      {
        label: "Langkah Antisipasi kejadian kritis dokter bedah",
        type: "checkbox_old",single:true,
        name: "pre_pembedahan_antisipasi_prosedur_kritis",
        value: 0,
        class:'mb-0',
        mandatory: false,
        optional:true,
        multiple: false,
        options: [
          {
            label: "Prosedur non rutin/kritis",
            value: 1
          },
        ],
      }
    ]
  },
  {
    colnum: 1,
    class:'mb-0',
    columns: [
      {
        type: "checkbox_old",single:true,
        name: "pre_pembedahan_antisipasi_durasi",
        value: 0,
        class:'mb-0',
        mandatory: false,
        optional:true,
        multiple: false,
        options: [
          {
            label: "Lama/durasi operasi",
            value: 1
          }
        ],
      }
    ]
  },
  {
    colnum: 1,
    columns: [
      {
        type: "checkbox_old",single:true,
        name: "pre_pembedahan_antisipasi_darah",
        value: 0,
        mandatory: false,
        optional:true,
        multiple: false,
        options: [
          {
            label: "Antisipasi kehilangan darah",
            value: 1
          }
        ],
      }
    ]
  },
  {
    colnum: 1,
    columns: [
      {
        label: "Anestesi",
        type: "checkbox_old",single:true,
        name: "pre_pembedahan_anestesi_monitor",
        value: 0,
        mandatory: false,
        optional:true,
        multiple: false,
        options: [
          {
            label: "Pasien perlu perhatian khusus memerlukan alat monitoring khusus",
            value: 1
          },
        ],
      }
    ]
  },
  {
    colnum: 1,
    columns: [
      {
        label: "",
        type: "text",
        placeholder: "",
        name: "pre_pembedahan_anestesi_monitor_keterangan",
        value: "",
        mandatory: false,
optional:true,
        additional: ""
      }
    ]
  },
  {
    colnum: 1,
    class:"mb-0",
    columns: [
      {
        label: "Perawat",
        type: "checkbox_old",single:true,
        name: "pre_pembedahan_perawat_instrumen",
        class:"mb-0",
        value: 0,
        mandatory: false,
        optional:true,
        multiple: false,
        options: [
          {
            label: "Instrument lengkap dan steril",
            value: 1
          },
        ],
      }
    ]
  },
  {
    colnum: 1,
    class:"mb-0",
    columns: [
      {
        label: "",
        type: "checkbox_old",single:true,
        name: "pre_pembedahan_perawat_instrumen_khusus",
        class:"mb-0",
        value: 0,
        mandatory: false,
        optional:true,
        multiple: false,
        options: [
          {
            label: "Ada peralatan yang perlu perhatian khusus",
            value: 1
          },
        ],
      }
    ]
  },
  {
    colnum: 1,
    columns: [
      {
        label: "",
        type: "text",
        placeholder: "",
        name: "pre_pembedahan_perawat_instrumen_khusus_keterangan",
        value: "",
        mandatory: false,
optional:true,
        additional: ""
      }
    ]
  },
  {
    colnum: 1,
    class:"mb-0",
    columns: [
      {
        label: "Pencegahan Infeksi",
        type: "checkbox_old",single:true,
        name: "pre_pembedahan_pencegahan_antibiotik",
        class:"mb-0",
        value: 0,
        mandatory: false,
        optional:true,
        multiple: false,
        options: [
          {
            label: "Pemberian antibiotik profilaksis",
            value: 1
          },
        ],
      }
    ]
  },
  {
    colnum: 1,
    class:"mb-0",
    columns: [
      {
        label: "",
        type: "checkbox_old",single:true,
        name: "pre_pembedahan_pencegahan_cukur_rambut",
        class:"mb-0",
        value: 0,
        mandatory: false,
        optional:true,
        multiple: false,
        options: [
          {
            label: "Cukur rambut",
            value: 1
          },
        ],
      }
    ]
  },
  {
    colnum: 1,
    class:"mb-0",
    columns: [
      {
        label: "",
        type: "checkbox_old",single:true,
        name: "pre_pembedahan_pencegahan_kontrol_gula",
        class:"mb-0",
        value: 0,
        mandatory: false,
        optional:true,
        multiple: false,
        options: [
          {
            label: "Kontrol gula darah",
            value: 1
          },
        ],
      }
    ]
  }
];
export let rightForm = [
 {
    colnum: 2,
    columns: [
      {
        label: "Sign out pukul",
        type: "time",
        placeholder: "",
        name: "sign_out",
        value: null,
        additional: ""
      }
    ]
    },
    {
      colnum: 1,
      class:"mb-0",
      columns: [
        {
          label: "",
          type: "checkbox_old",single:true,
          header:"SEBELUM PASIEN MENINGGALKAN KAMAR OPERASI",
          name: "post_prosedur_dicatat",
          class:"mb-0",
          value: 0,
          mandatory: false,
          optional:true,
          multiple: false,
          options: [
            {
              label: "Nama prosedur harus dicatat",
              value: 1
            }
          ],
        }
      ]
    },
    {
      colnum: 1,
      class:"mb-0",
      columns: [
        {
          label: "",
          type: "checkbox_old",single:true,
          name: "post_kelengkapan_instrumen",
          class:"mb-0",
          value: 0,
          mandatory: false,
          optional:true,
          multiple: false,
          options: [
            {
              label: "Instrumen,kasa,jarum yang digunakan sudah dihitung dan lengkap",
              value: 1
            }
          ],
        }
      ]
  },
  {
    colnum: 1,
    class:"mb-0",
    columns: [
      {
        label: "",
        type: "checkbox_old",single:true,
        name: "post_diberi_label",
        class:"mb-0",
        value: 0,
        mandatory: false,
        optional:true,
        multiple: false,
        options: [
          {
            label: "Hasil operasi sudah diberi label dan benar",
            value: 1
          }
        ],
      }
    ]
  },
  {
    colnum: 1,
    class:"mb-0",
    columns: [
      {
        label: "",
        type: "checkbox_old",single:true,
        name: "post_masalah_peralatan",
        class:"mb-0",
        value: 0,
        mandatory: false,
        optional:true,
        multiple: false,
        options: [
          {
            label: "Apakah ditemukan masalah pada peralatan yang perlu dilaporkan",
            value: 1
          }
        ],
      }
    ]
  },
  {
    colnum: 1,
    columns: [
      {
        label: "",
        type: "textarea",regex:/^.{0,255}$/,regexError:"Melebihi batas maksimal (255 karakter)",
        placeholder: "max. 255 karakter",
        name: "post_masalah_peralatan_keterangan",
        value: "",
        mandatory: false,
        optional:true,
        additional: ""
      }
    ]
  },
  {
    colnum: 1,
    columns: [
      {
        header:"Semua anggota tim",
        label: "Apa yang diperlukan dan diperhatikan untuk pemulihan dan penanganan pasien?",
        type: "textarea",regex:/^.{0,255}$/,regexError:"Melebihi batas maksimal (255 karakter)",
        placeholder: "max. 255 karakter",
        name: "post_perhatian_pasien",
        value: "",
        mandatory: false,
        optional:true,
        additional: ""
      }
    ]
  },
];